import { RootState } from 'src/store';
import { getRevyreState } from '../selectors';

export const getBulkDownloadJobData = (state: RootState, jobId: string) =>
  getRevyreState(state)?.ddp?.jobDetails?.[jobId] || {};

export const getCurrentJobId = (state: RootState) =>
  getRevyreState(state)?.ddp.currentJobId;

export const getJobStatus = (state: RootState) =>
  getRevyreState(state)?.ddp.isJobLoading;
